import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
class Internships extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="container fade" style={{textAlign:"center"}}>
                <h1>INTERNSHIPS</h1>
                <div className="row">
                    <div className="col col-3 col-md-2 col-sm-1 d-xs-none">

                    </div>
                    <div className="col col-6 col-md-8 col-sm-12">
                    <Card>
                            <Card.Img src="/images/mathworks.png"/>
                            <Card.Title>Engineering Development Group Intern</Card.Title>
                            <Card.Subtitle>Company : MathWorks</Card.Subtitle>
                            <Card.Body style={{textAlign:"left"}}>
                                <Card.Text>
                                • Worked on Advanced C++
                                
                                </Card.Text>
                                <Card.Text>
                                • Solved technical issues of Customers worldwide
                                </Card.Text>

                                <Card.Text>
                                • Organized events for various trainings

                                </Card.Text>
                            </Card.Body>
                        </Card>
                        <Card>
                            <Card.Img src="/images/iiitv.png"/>
                            <Card.Title>Teaching Assistant</Card.Title>
                            <Card.Subtitle>Indian Institute of Information Technology Vadodara</Card.Subtitle>
                            <Card.Body style={{textAlign:"left"}}>
                                <Card.Text>
                                • Worked as a teaching Assistant for Formal Language and automata theory Course

                                </Card.Text>
                                <Card.Text>
                                • Created quizes, mock tests and graded assignments
                                </Card.Text>

                                <Card.Text>
                                • Gave presentations on related topics

                                </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card>
                            <Card.Img src="/images/internship.jpg"/>
                            <Card.Title>Frontend Developer Intern</Card.Title>
                            <Card.Subtitle>Company : Plaqsha</Card.Subtitle>
                            <Card.Body style={{textAlign:"left"}}>
                                <Card.Text>
                                • Developed Admin Panel for managing users
                                
                                </Card.Text>
                                <Card.Text>
                                • Developed Module management panel for managing learning paths
                                </Card.Text>

                                <Card.Text>
                                • Integrated API’s for joint functionality

                                </Card.Text>
                            </Card.Body>
                        </Card>

                        
                    </div>
                    <div className="col col-3 col-md-2 col-sm-1 d-xs-none">

                   </div>

                </div>
                
            </div>
        );
    }
}

Internships.propTypes = {};

export default Internships;
